import '../App.css';

const TodoApp = () => {
    return (
        <div>
        
        <div className="appPages">
        <iframe title="To Do App" src="https://todotodos.netlify.app/" width="100%" height="99.4%" ></iframe>
        </div>
        </div>
        
    )
}
export default TodoApp